import React from 'react';

const Donate: React.FC = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="bg-gold text-white py-16">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-6 text-white">Faire un don</h1>
          <p className="text-xl max-w-3xl mx-auto">
            Votre générosité permet de soutenir nos actions auprès des femmes et des enfants
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold mb-6">Pourquoi donner ?</h2>
              <p className="text-lg mb-4">
                Votre don à MoreLove contribue directement à améliorer la vie des femmes et des enfants 
                dans le besoin. Chaque contribution, quelle que soit sa taille, fait une différence significative.
              </p>
              <p className="text-lg mb-8">
                En tant qu'organisation à but non lucratif 501(c)(3), vos dons peuvent être déductibles 
                d'impôts selon la législation en vigueur.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
              <div className="card">
                <h3 className="text-xl font-bold mb-4 text-primary">Impact de votre don</h3>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Soutien aux programmes d'évangélisation</li>
                  <li>Aide alimentaire et matérielle aux familles</li>
                  <li>Éducation et formation pour les femmes</li>
                  <li>Soins de santé pour les enfants vulnérables</li>
                  <li>Développement de projets générateurs de revenus</li>
                  <li>Expansion de nos programmes dans de nouvelles régions</li>
                </ul>
              </div>
              <div className="card">
                <h3 className="text-xl font-bold mb-4 text-primary">Transparence</h3>
                <p className="mb-4">
                  Chez MoreLove, nous nous engageons à utiliser vos dons avec intégrité et transparence :
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>85% des dons sont directement alloués aux programmes sur le terrain</li>
                  <li>10% sont utilisés pour l'administration et la gestion</li>
                  <li>5% sont consacrés à la sensibilisation et à la collecte de fonds</li>
                  <li>Rapports réguliers sur l'utilisation des fonds</li>
                </ul>
              </div>
            </div>

            {/* Donation Options */}
            <div className="mb-16">
              <h2 className="text-3xl font-bold mb-8 text-center">Options de don</h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className="card text-center">
                  <h3 className="text-xl font-bold mb-4 text-primary">Don unique</h3>
                  <p className="mb-6">
                    Soutenez nos actions avec un don ponctuel du montant de votre choix.
                  </p>
                  <button className="btn-primary">Faire un don unique</button>
                </div>
                <div className="card text-center">
                  <h3 className="text-xl font-bold mb-4 text-primary">Don mensuel</h3>
                  <p className="mb-6">
                    Devenez un partenaire régulier et soutenez nos actions dans la durée.
                  </p>
                  <button className="btn-primary">Devenir donateur mensuel</button>
                </div>
                <div className="card text-center">
                  <h3 className="text-xl font-bold mb-4 text-primary">Don spécifique</h3>
                  <p className="mb-6">
                    Choisissez un projet ou un domaine d'intervention particulier à soutenir.
                  </p>
                  <button className="btn-primary">Choisir un projet</button>
                </div>
              </div>
            </div>

            {/* Donation Form */}
            <div>
              <h2 className="text-3xl font-bold mb-6 text-center">Formulaire de don</h2>
              <div className="card">
                <form className="space-y-6">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <label htmlFor="firstName" className="block text-sm font-medium text-gray-700 mb-1">
                        Prénom
                      </label>
                      <input
                        type="text"
                        id="firstName"
                        className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-primary focus:border-primary"
                        required
                      />
                    </div>
                    <div>
                      <label htmlFor="lastName" className="block text-sm font-medium text-gray-700 mb-1">
                        Nom
                      </label>
                      <input
                        type="text"
                        id="lastName"
                        className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-primary focus:border-primary"
                        required
                      />
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
                        Email
                      </label>
                      <input
                        type="email"
                        id="email"
                        className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-primary focus:border-primary"
                        required
                      />
                    </div>
                    <div>
                      <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1">
                        Téléphone
                      </label>
                      <input
                        type="tel"
                        id="phone"
                        className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-primary focus:border-primary"
                      />
                    </div>
                  </div>

                  <div>
                    <label htmlFor="donationType" className="block text-sm font-medium text-gray-700 mb-1">
                      Type de don
                    </label>
                    <select
                      id="donationType"
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-primary focus:border-primary"
                      required
                    >
                      <option value="">Sélectionnez une option</option>
                      <option value="unique">Don unique</option>
                      <option value="mensuel">Don mensuel</option>
                      <option value="specifique">Don pour un projet spécifique</option>
                    </select>
                  </div>

                  <div>
                    <label htmlFor="amount" className="block text-sm font-medium text-gray-700 mb-1">
                      Montant du don ($)
                    </label>
                    <input
                      type="number"
                      id="amount"
                      min="1"
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-primary focus:border-primary"
                      required
                    />
                  </div>

                  <div>
                    <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1">
                      Message (optionnel)
                    </label>
                    <textarea
                      id="message"
                      rows={4}
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-primary focus:border-primary"
                    ></textarea>
                  </div>

                  <div className="text-center">
                    <button type="submit" className="btn-donate">
                      Faire un don maintenant
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonial Section */}
      <section className="py-16 bg-light">
        <div className="container mx-auto px-4 text-center">
          <blockquote className="text-xl my-8 max-w-3xl mx-auto">
            "Mais par dessus toute ces choses, revêtez-vous de la charité qui est le lien de la perfection"
            <footer className="mt-2">Colossiens 3:14</footer>
          </blockquote>
        </div>
      </section>
    </div>
  );
};

export default Donate;
